import AnimatedListPointer from './AnimatedListPointer';

export default AnimatedListPointer;



// WEBPACK FOOTER //
// ./scripts/elements/AnimatedListPointer/index.js